import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SpecialistRecommendationModule} from 'app/core/specialist-recommendation/specialist-recommendation.module';
import {UserDisplayModule} from 'app/core/user-display/user-display.module';
// eslint-disable-next-line max-len
import {DiaryWarningCardModule} from 'app/departures/departure/diary-view/diary-event-card/diary-properties-card/diary-warning-card/diary-warning-card.module';
import {StyleableTextModule} from './styleable-text/styleable-text.module';
import {TemplateRoleModule} from './template-role/template-role.module';
import {TemplateStringComponent} from './template-string/template-string.component';
import {TemplatiserComponent} from './templatiser.component';

@NgModule({
  imports: [
    CommonModule,
    UserDisplayModule,
    DiaryWarningCardModule,
    SpecialistRecommendationModule,
    TemplateRoleModule,
    StyleableTextModule
  ],
  declarations: [TemplatiserComponent, TemplateStringComponent],
  exports: [TemplatiserComponent]
})
export class TemplatiserModule {}
